var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-wrapper"},[_c('header',[_vm._t("header")],2),_c('section',[_vm._t("section")],2),_vm._t("footer")],2)}
var staticRenderFns = []

export { render, staticRenderFns }